// About ua page
document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/pages/about-us-page") {
        const heading = document.querySelector(
            '.multiple-media-with-text__content-wrapper .prose p.h3'
        );

        if (heading) {
            const h1 = document.createElement("h1");
            h1.className = heading.className;
            h1.innerHTML = heading.innerHTML;

            heading.parentNode.replaceChild(h1, heading);
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/pages/saunum-technology") {
        const heading = document.querySelector(
            '.slideshow__slide-content .prose p.h1'
        );

        if (heading) {
            const h1 = document.createElement("h1");
            h1.className = heading.className;
            h1.innerHTML = heading.innerHTML;

            heading.parentNode.replaceChild(h1, heading);
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/pages/event-space") {
        const heading = document.querySelector(
            '.slideshow__slide-content .prose p.h1'
        );

        if (heading) {
            const h1 = document.createElement("h1");
            h1.className = heading.className;
            h1.innerHTML = heading.innerHTML;

            heading.parentNode.replaceChild(h1, heading);
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/pages/faqs") {
        const heading = document.querySelector(
            '.section-header .prose h2.h2'
        );

        if (heading) {
            const h1 = document.createElement("h1");
            h1.className = heading.className;
            h1.innerHTML = heading.innerHTML;

            heading.parentNode.replaceChild(h1, heading);
        }
    }
});

// Thank you page

